import type { NextRouter } from 'next/router';

const getPathParamKeys = (pathname: string) =>
  new Set(
    [...pathname.matchAll(/\[(?:\.\.\.)?([^\]]+)]/g)].map((match) => match[1]),
  );

export const pushCatalogQuery = (
  router: Pick<NextRouter, 'asPath' | 'pathname' | 'push'>,
  query: Record<string, unknown>,
  options?: { shallow?: boolean },
) => {
  const pathname = router.asPath.split('?')[0];
  const pathParamKeys = getPathParamKeys(router.pathname);
  const nextQuery: Record<string, string> = {};

  Object.entries(query).forEach(([key, value]) => {
    if (pathParamKeys.has(key) || value == null || value === '') return;
    const normalized = Array.isArray(value) ? value[0] : value;
    if (normalized == null || normalized === '') return;
    nextQuery[key] = String(normalized);
  });

  return router.push({ pathname, query: nextQuery }, undefined, {
    shallow: options?.shallow,
  });
};
